import { cn } from '@/lib/utils';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const FieldsetFooter = ({ children, className }: Props) => {
  return (
    <div className={cn('mt-6 flex items-center justify-between gap-3', className)}>{children}</div>
  );
};

export default FieldsetFooter;
